import { axiosInstanceV2 } from "@src/shared/api";
import { TCandidateRating } from "@src/shared/types";
import { RATING_API_URL } from "../constants";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

type TSetCandidateRatingParams = {
  requestUuid: string;
  candidateId: string;
  rating: Exclude<TCandidateRating, null>;
};

export const setCandidateRating = ({
  requestUuid,
  candidateId,
  rating,
}: TSetCandidateRatingParams) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;

  return axiosInstanceV2.post(
    RATING_API_URL.setCandidateRating(requestUuid, candidateId),
    {
      rating,
    },
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );
};
